import {
  externalHealthSchema,
  receiptSchema,
  runListResponseSchema,
  type ExternalHealth,
  type Receipt,
  type RunListQuery,
  type RunListResponse,
} from '@console/types'
import { apiGet } from '../api.js'

/**
 * Builds the same querystring shape the backend's `runsQuerystringSchema`
 * (and, one hop further, the fake Cadence server) both parse — one filter
 * schema, three consumers (phase plan §0).
 */
function queryToSearchParams(query: RunListQuery): URLSearchParams {
  const params = new URLSearchParams()
  const f = query.filter

  if (f.verdict !== undefined) params.set('verdict', f.verdict)
  if (f.dateFrom !== undefined) params.set('dateFrom', f.dateFrom)
  if (f.dateTo !== undefined) params.set('dateTo', f.dateTo)
  if (f.customer !== undefined) params.set('customer', f.customer)
  if (f.actionType !== undefined) params.set('actionType', f.actionType)
  if (f.ruleFired !== undefined) params.set('ruleFired', f.ruleFired)
  if (f.lineItemContains !== undefined) params.set('lineItemContains', f.lineItemContains)
  if (f.amountAbove !== undefined) params.set('amountAbove', String(f.amountAbove))
  params.set('sort', query.sort)
  params.set('sortDirection', query.sortDirection)
  params.set('offset', String(query.offset))
  params.set('limit', String(query.limit))

  return params
}

export async function fetchRuns(query: RunListQuery): Promise<RunListResponse> {
  return apiGet(`/runs?${queryToSearchParams(query).toString()}`, runListResponseSchema)
}

export async function fetchRun(id: string): Promise<Receipt> {
  return apiGet(`/runs/${encodeURIComponent(id)}`, receiptSchema)
}

export async function fetchExternalHealth(): Promise<ExternalHealth> {
  return apiGet('/health/external', externalHealthSchema)
}
